import { basePath, apiVersion } from "./config";

export function getCategoriesApi(){
    const url = `${basePath}/${apiVersion}/get-categories`;

    return fetch(url)
            .then(response => {
                return response.json();
            })
            .then(result => {
                return result;
            })
            .catch(err => {
                return err;
            })
}

export function getCategoryApi(token, id) {
    const url = `${basePath}/${apiVersion}/get-category/${id}`;

    const params = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: token
        }
    };
  
    return fetch(url, params)
      .then(response => {
        return response.json();
      })
      .then(result => {
        return result;
      })
      .catch(err => {
        return err;
    });
}

export function deleteCategoryApi(token, id) {
    const url = `${basePath}/${apiVersion}/del-category/${id}`;

    const params = {
        method: "DELETE",
        headers: {
        "Content-Type": "application/json",
        Authorization: token
        }
    };

    return fetch(url, params)
        .then(response => {
        return response.json();
        })
        .then(result => {
        return result;
        })
        .catch(err => {
        return err;
    });
}

export function updateCategoryApi(token, categoria, id) {
    const url = `${basePath}/${apiVersion}/upd-category/${id}`;

    const params = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: token
        },
        body: JSON.stringify(categoria)
    }

    return fetch(url, params).then(response => {
        return response.json();
    }).then(result => {
        return result;
    }).catch(err => {
        return err.message;
    });
}

export function getCatWithoutNotesApi(){
    const url = `${basePath}/${apiVersion}/get-catwithoutnotes`;

    return fetch(url)
      .then(response => {
        return response.json();
      })
      .then(result => {
        return result;
      })
      .catch(err => {
        return err;
    });
}

export function getCatReleaseNotesApi(token){
    const url = `${basePath}/${apiVersion}/get-catrnotes`;

    const params = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: token
        }
    };
  
    return fetch(url, params)
      .then(response => {
        return response.json();
      })
      .then(result => {
        return result;
      })
      .catch(err => {
        return err;
    });
}